import { Component, OnInit, TemplateRef } from '@angular/core';
import { ReportService } from '../../../services/report.service';
import { Report, ReportType, DataType, ColumnDefinition, FilterColumn } from '../../../models/Report';
import { ActivatedRoute } from '@angular/router';
import { AlertService } from '../../../shared/services/alert.service';
import {BsModalService} from 'ngx-bootstrap/modal';
import {BsModalRef} from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ErrorHandlerService } from '../../../services/error-handler.service';


@Component({
  selector: 'app-report-detail-config',
  templateUrl: './report-detail-config.component.html',
  styleUrls: ['./report-detail-config.component.css']
})
export class ReportDetailConfigComponent implements OnInit {

  report : Report;
  editReport : Report;
  reportTypes : ReportType[] = []
  modalRef: BsModalRef;
  editColumnDefinition : boolean = false;
  editFilterColumn: boolean = false;
  dataTypes: Array <DataType> = [{id : 1, name : "Date"}, {id : 2, name : "DateRange"}, {id : 3, name : "Decimal"},
                                  {id : 4, name : "Integer"}, {id : 5, name : "Numeric"}, {id : 6, name : "String"}];
  columnDefinition : ColumnDefinition;
  currentColumnDefinitionIndex : number;
  filterColumn: FilterColumn;
  currentFilterColumnIndex: number;
  deletionSelector : boolean = false;
  reportGroups = [ {code : "ILICENSE" , name: "i-License"},
                   {code : "IINSPECT" , name: "i-Inspect"}
                ];

  constructor(private reportService: ReportService, private route: ActivatedRoute, private modalService: BsModalService,
    private alertService: AlertService,private spinner: NgxSpinnerService, private errorHandlerService: ErrorHandlerService) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.reportService.getReport(params['id']).subscribe(resp => {
        this.report = resp;
      });      
    });

    this.reportService.getReportTypes().subscribe(resp => {
      this.reportTypes = resp;
    });
  }

  showEditReportModal(template: TemplateRef < any >){
    this.editReport = Object.assign({}, this.report);
    this.modalRef = this.modalService.show(template, {backdrop: 'static', keyboard: false});
  }

  updateReport(){
    this.spinner.show();
    this.editReport.reportType = null;
    this.reportService.updateReport(this.editReport).subscribe(
      resp => {
        if(resp){
          this.editReport.reportType = this.reportTypes.find(x => x.id == this.editReport.reportTypeID);
          this.report = this.editReport;  
          this.alertService.success('Report Updated Successfully');
        } else {
          this.alertService.error('Unable to Update Report');
        }
        this.modalRef.hide();
        this.spinner.hide();
      },
      error => {
          let errorMsg = this.errorHandlerService.handleApiError(error);
          this.alertService.error(errorMsg + ' , please try again');
          this.modalRef.hide();
          this.spinner.hide();  
      }
    );
  }

  closeModal(){
    this.editReport = null;
    this.modalRef.hide();
  }

  
  updateIsVisible(){
    this.columnDefinition.isVisible = !this.columnDefinition.isVisible;
  }

  updateIsSortable(){
    this.columnDefinition.isSortable = !this.columnDefinition.isSortable;
  }

  showCreateColumnDefinitionModal(columnDefnTemplate: TemplateRef < any >){
    this.editColumnDefinition = false;
    this.columnDefinition = new ColumnDefinition();
    this.modalRef = this.modalService.show(columnDefnTemplate, {backdrop: 'static', keyboard: false});
  }

  showEditColumnDefinitionModal(columnDefnTemplate: TemplateRef < any >, itemIndex : number){
    this.editColumnDefinition = true;
    this.currentColumnDefinitionIndex = itemIndex;
    this.columnDefinition = this.report.columnDefinitions[itemIndex];
    this.modalRef = this.modalService.show(columnDefnTemplate, {backdrop: 'static', keyboard: false});
  }

  showDeleteColumnDefinitionModal(columnDefnTemplate: TemplateRef < any >, itemIndex : number){
    this.currentColumnDefinitionIndex = itemIndex;
    this.deletionSelector = false; 
    this.modalRef = this.modalService.show(columnDefnTemplate, {backdrop: 'static', keyboard: false});
  }

  addColumnDefinition(){
    this.spinner.show();
    let dataType = this.dataTypes.find(d => d.id == this.columnDefinition.dDataType.id);
    this.columnDefinition.dataType = dataType.name;
    this.columnDefinition.dDataType = dataType;
    this.report.columnDefinitions.push(this.columnDefinition); 
    this.report.columnDefinitionsStr = JSON.stringify(this.report.columnDefinitions);
    this.reportService.updateReport(this.report).subscribe(
      resp => {
        if(resp){
          this.alertService.success('Column Definition Added Successfully');
        } else {
          this.alertService.error('Unable to Add Column Definition');
        }
        this.modalRef.hide();
        this.spinner.hide();
      },
      error => {
          let errorMsg = this.errorHandlerService.handleApiError(error);
          this.alertService.error(errorMsg + ' , please try again');
          this.modalRef.hide();
          this.spinner.hide();  
      }
    );
  }

  updateColumnDefinition(){
    this.spinner.show();
    let dataType = this.dataTypes.find(d => d.id == this.columnDefinition.dDataType.id);
    this.columnDefinition.dataType = dataType.name;
    this.columnDefinition.dDataType = dataType;
    this.report.columnDefinitions[this.currentColumnDefinitionIndex] = this.columnDefinition;
    this.report.columnDefinitionsStr = JSON.stringify(this.report.columnDefinitions);
    this.reportService.updateReport(this.report).subscribe(
      resp => {
        if(resp){
          this.alertService.success('Column Definition Updated Successfully');
        } else {
          this.alertService.error('Unable to Update Column Definition');
        }
        this.modalRef.hide();
        this.spinner.hide();
      },
      error => {
          let errorMsg = this.errorHandlerService.handleApiError(error);
          this.alertService.error(errorMsg + ' , please try again');
          this.modalRef.hide();
          this.spinner.hide();  
      }
    );
  }

  deleteColumnDefinition(){
    this.spinner.show();
    this.report.columnDefinitions.splice(this.currentColumnDefinitionIndex, 1);
    this.report.columnDefinitionsStr = JSON.stringify(this.report.columnDefinitions);
    this.reportService.updateReport(this.report).subscribe(
      resp => {
        if(resp){
          this.alertService.success('Column Definition Deleted Successfully');
        } else {
          this.alertService.error('Unable to Delete Column Definition');
        }
        this.modalRef.hide();
        this.spinner.hide();
      },
      error => {
          let errorMsg = this.errorHandlerService.handleApiError(error);
          this.alertService.error(errorMsg + ' , please try again');
          this.modalRef.hide();
          this.spinner.hide();  
      }
    );
  }

  showCreateFilterModal(filterTemplate: TemplateRef<any>){
    this.editFilterColumn = false;
    this.filterColumn = new FilterColumn();
    this.modalRef = this.modalService.show(filterTemplate, {backdrop: 'static', keyboard: false});
  }

  showEditFilterModal(filterTemplate: TemplateRef<any>, itemIndex: number){
    this.editFilterColumn = true;
    this.currentFilterColumnIndex = itemIndex;
    this.filterColumn = this.report.filterColumns[itemIndex];
    this.modalRef = this.modalService.show(filterTemplate, {backdrop: 'static', keyboard: false});
  }

  showDeleteFilterModal(template: TemplateRef<any>, itemIndex: number){
    this.currentFilterColumnIndex = itemIndex;
    this.deletionSelector = true; 
    this.modalRef = this.modalService.show(template, {backdrop: 'static', keyboard: false});
  }
 
  addFilter(){
    this.spinner.show();
    let dataType = this.dataTypes.find(d => d.id == this.filterColumn.dType.id);
    this.filterColumn.type = dataType.name;
    this.filterColumn.dType = dataType;
    this.report.filterColumns.push(this.filterColumn); 
    this.report.filterColumnsStr = JSON.stringify(this.report.filterColumns);
    this.reportService.updateReport(this.report).subscribe(
      resp => {
        if(resp){
          this.alertService.success('Filter Column Added Successfully');
        } else {
          this.alertService.error('Unable to Add Filter Column');
        }
        this.modalRef.hide();
        this.spinner.hide();
      },
      error => {
          let errorMsg = this.errorHandlerService.handleApiError(error);
          this.alertService.error(errorMsg + ' , please try again');
          this.modalRef.hide();
          this.spinner.hide();  
      }
    );
  }

  updateFilter(){
    this.spinner.show();
    let dataType = this.dataTypes.find(d => d.id == this.filterColumn.dType.id);
    this.filterColumn.type = dataType.name;
    this.filterColumn.dType = dataType;
    this.report.filterColumns[this.currentFilterColumnIndex] = this.filterColumn;
    this.report.filterColumnsStr = JSON.stringify(this.report.filterColumns);
    this.reportService.updateReport(this.report).subscribe(
      resp => {
        if(resp){
          this.alertService.success('Filter Column Updated Successfully');
        } else {
          this.alertService.error('Unable to Update Filter');
        }
        this.modalRef.hide();
        this.spinner.hide();
      },
      error => {
          let errorMsg = this.errorHandlerService.handleApiError(error);
          this.alertService.error(errorMsg + ' , please try again');
          this.modalRef.hide();
          this.spinner.hide();  
      }
    );
  }

  deleteFilter(){
    this.spinner.show();
    this.report.filterColumns.splice(this.currentFilterColumnIndex, 1);
    this.report.filterColumnsStr = JSON.stringify(this.report.filterColumns);
    this.reportService.updateReport(this.report).subscribe(
      resp => {
        if(resp){
          this.alertService.success('Filter Column Deleted Successfully');
        } else {
          this.alertService.error('Unable to Delete Filter Column');
        }
        this.modalRef.hide();
        this.spinner.hide();
      },
      error => {
          let errorMsg = this.errorHandlerService.handleApiError(error);
          this.alertService.error(errorMsg + ' , please try again');
          this.modalRef.hide();
          this.spinner.hide();  
      }
    );
  }

  updateInnerFilter(){
    this.filterColumn.isInnerFilter = !this.filterColumn.isInnerFilter;
  }
}
